<template>
  <div
    v-if="loadingDataError === false"
    class="SpremembaStoritevComponent"
    v-loading="loading"
    element-loading-text="Pripravljamo pogodbene dokumente. Prosimo, počakajte."
  >
    <template v-if="!loading && validData">
      <template v-if="order.id !== null">
        <el-steps :active="activeStep" simple finish-status="seaGreenText" class="my-2">
          <el-step
            v-for="(step, index) in numberOfSteps"
            :key="`spremembaStoritevStepper-${index}`"
            :title="$screen.breakpoint === 'xs' ? `${index + 1}` : `Korak ${index + 1}`"
            icon="el-icon-document"
            @click="activeStep = index"
          />
        </el-steps>
        <template v-if="order.documents[activeStep] !== undefined">
          <embed
            :src="order.documents[activeStep].getContentForEmbedded(true)"
            type="application/pdf"
            width="100%"
            style="flex:auto; background-color: lightgrey;"
            v-if="$screen.xl"
          />
          <PrikazPdf
            v-if="!$screen.xl"
            type="base64"
            :source="order.documents[activeStep].getContentForEmbedded(false)"
            style="flex:auto; overflow-y: auto;"
            :title="order.documents[activeStep].title"
          />
          <div class="pt-1">
            Imate problem z ogledom dokumenta? Kliknite
            <a
              :href="order.documents[activeStep].getContentForEmbedded()"
              :download="order.documents[activeStep].title.replaceAll(' ', '_') + '.pdf'"
              class="primarna-barva"
              ref="docsPDFDownloader"
              @click.prevent="handleDownload"
            >tukaj</a>
          </div>
        </template>
<!--        <template v-else>-->
<!--          <div style="flex: auto;"></div>-->
<!--        </template>-->
        <div style="word-break: break-word;text-align: justify;">
          <template v-if="isFinalStep && order.isSubscription">
            <div class=" pt-6">
              <template v-for="(service, index) in order.services">
                <template v-if="service.serviceId === StoritevEnum.APLIKACIJA_T2_TV">
                  <div class="open-sans-18pt">Aplikacija T-2 TV za Smart TV</div>
                  <div class="my-4">
                    Za aktivacijo aplikacije vnesete kodo, ki se prikaže ob prvem zagonu naprave, na katero ste namestili aplikacijo.
                  </div>
                  <el-form :model="service.additionalData" :rules="rules" ref="T2TVSmartForm" class="mb-8">
                    <el-form-item label="" prop="smartTvAppRules">
                      <el-input
                        placeholder="Vpišite T-2 TV kodo"
                        v-model="service.additionalData.smartTvApp"
                        class="velikost-input"
                        style="max-width: 300px;"
                        @input="$refs['T2TVSmartForm'][0].resetFields();"
                      />
                    </el-form-item>
                  </el-form>
                </template>
              </template>
              <div class="open-sans-18pt pb-2">Naročilo z obveznostjo plačila</div>
              <div style="display: flex;" class="mt-2">
                <el-checkbox v-model="strinjanjePogodba" />
                <div class="pl-2" style="cursor: pointer" @click="strinjanjePogodba = !strinjanjePogodba">
                  Prebral/a sem in se strinjam s pogodbenimi določili, ki sem jih dobil/a v predogled, ter pripadajočimi
                  splošnimi oziroma posebnimi pogoji, na katere se te dokumenti sklicujejo, ki so dostopni
                  <a class="primarna-barva" href="https://www.t-2.net/splosni-pogoji-podjetja" target="_blank">tukaj</a>.
                </div>
              </div>
              <div style="display: flex;" class="mt-2">
                <el-checkbox v-model="strinjanjeIzgubaPraviceDoOdstopa" />
                <div class="pl-2" style="cursor: pointer" @click="strinjanjeIzgubaPraviceDoOdstopa = !strinjanjeIzgubaPraviceDoOdstopa">
                  Seznanjen/a sem, da imajo potrošniki pravico odstopiti od pogodbe, sklenjene na daljavo, v 14 dneh
                  (134. člen ZVPot-1). Soglašam, da se v primeru sklenitve pogodbe za dobavo digitalne vsebine, ki ni na
                  trajnem nosilcu, izvajanje pogodbe začne že med odstopnim rokom, če je to mogoče. V tem primeru
                  razumem in se strinjam, da izgubim pravico do odstopa od pogodbe v 14 dneh
                  (13. točka 135. člena ZVPot-1). Prav tako soglašam, da se v primeru sklenitve pogodbe o opravljanju
                  storitve ta začne izvajati že med odstopnim rokom, če je to mogoče, in se strinjam, da izgubim pravico
                  do odstopa od pogodbe v 14 dneh, ko T-2 storitev izpolni (4. točka 135. člena ZVPot-1). Seznanjen sem
                  in se strinjam, da v primeru, če odstopim od pogodbe po tem, ko sem zahteval,
                  da T-2 začne opravljati storitev v 14-dnevnem odstopnem roku, plačam družbi T-2 sorazmerni znesek
                  mesečne naročnine do dneva obvestitve družbe T-2 o odstopu od pogodbe.
                  <a
                    class="primarna-barva"
                    href="https://www.t-2.net/odstop-od-pogodbe-za-dobavo-storitev-ali-digitalne-vsebine-potrosniki"
                    target="_blank"
                  >Več o tem</a>.
                </div>
              </div>
              <div style="display: flex;" class="mt-2" v-for="checkbox in documentsCheckboxes">
                <el-checkbox v-model="checkbox.value" />
                <div class="pl-2" style="cursor: pointer" @click="checkbox.value = !checkbox.value">
                  {{checkbox.text}}
                </div>
              </div>
            </div>
          </template>
          <template v-if="isFinalStep && !order.isSubscription">
            <div class="open-sans-18pt pt-6">Naročilo spremembe naročenih storitev</div>
            <div style="display: flex;" class="mt-2">
              <el-checkbox v-model="strinjanjePogodba" />
              <div class="pl-2" style="cursor: pointer" @click="strinjanjePogodba = !strinjanjePogodba">
                Prebral/a sem in se strinjam s pogodbenimi določili, ki sem jih dobil/a v predogled, ter pripadajočimi
                splošnimi oziroma posebnimi pogoji, na katere se te dokumenti sklicujejo, ki so dostopni
                <a class="primarna-barva" href="https://www.t-2.net/splosni-pogoji-podjetja" target="_blank">tukaj</a>.
              </div>
            </div>
          </template>
          <div :class="`d-flex ${isFinalStep ? 'finalStep' : ''} mt-3`" id="orderButtonsDiv">
            <div style="flex:auto;" class="mt-1">
              <el-button
                v-show="isFinalStep"
                type="primary"
                class="gumb-potrdi uppercase pt-2 mt-2"
                style="font-weight: bold;"
                :disabled="isDisabledNarocilo || loadingPotrdi || documentsCheckboxes.find(x => x.value === false)"
                @click="confirmChange()"
                v-loading="loadingPotrdi"
              >
                Naročam spremembo storitev
              </el-button>
              <el-button
                :disabled="isFinalStep"
                v-if="!isFinalStep"
                type="primary"
                class="gumb-potrdi uppercase ml-0"
                style="width: 100px;"
                @click="activeStep++"
              >
                Naprej
              </el-button>
            </div>
            <div class="mt-1 right">
              <el-button
                v-if="activeStep !== 0"
                class="gumb-crni-okvir uppercase mt-2"
                style="width: 100px;"
                @click="activeStep--"
              >
                Nazaj
              </el-button>
            </div>
          </div>
        </div>
        <el-dialog
          top="200px"
          width="530px"
          append-to-body
          :visible.sync="pokaziSuccessPopup"
          :show-close="false"
          custom-class="spremembaStoritevSuccessDialog">
          <div class="d-flex" style="flex-direction: column; text-align: center">
            <div class="ikona-uspesno mt-2">
              <img src="/static/img/MojProfil/Icon-feather-check.png">
            </div>
            <div style="font-weight: bold;">{{order.getFinalNotificationTitle()}}</div>
            <div class="mt-3" style="word-break: break-word;" v-html="order.getFinalNotificationText()"/>
            <div style="text-align: center;" class="mt-5">
              <el-button class="gumb-crni-okvir" style="width: 100px; border: none !important;" @click="pokaziSuccessPopup = false">
                Zapri
              </el-button>
            </div>
          </div>
        </el-dialog>
      </template>
      <div v-else style="flex:auto; display: flex; flex-direction: column">
        <div style="flex: auto;align-content: center; text-align: center;" class="open-sans-18pt">
          Pri kreiranju naročila je prišlo do napake.
        </div>
      </div>
    </template>
  </div>
  <div v-else style="flex: 1; display: flex;">
    <div style="font-size: 14px; color: red; width: 100%; text-align: center;align-content: center;">
      Pri ustvarjanju dokumentov je prišlo do napake. <br/>Prosimo, poskusite znova kasneje ali nas pokličite na 064 064 064.
    </div>
  </div>
</template>

<script>
import {Steps, Step, Checkbox, Button, Dialog, Icon, Input, Form, FormItem} from 'element-ui'
import Order from '../../../../assets/js/Order/Order'
import {StoritevEnum} from '../../../../assets/js/Enum/StoritevEnum'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import PrikazPdf from '../../../UIComponents/PrikazPdf.vue'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

export default {
  name: 'SpremembaStoritevComponent',
  mixins: [PrenosDatoteke],
  components: {
    PrikazPdf,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem
  },
  emits: ['orderConfirmed', 'notificationClose'],
  props: {
    services: {
      type: Array,
      required: true
    },
    serviceName: {
      type: String,
      required: true
    },
    cancelOrder: {
      type: Boolean,
      default: false
    },
    lowerQuantity: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      validData: false,
      pokaziSuccessPopup: false,
      activeStep: 0,
      strinjanjePogodba: false,
      strinjanjeIzgubaPraviceDoOdstopa: false,
      loading: true,
      order: new Order(),
      loadingPotrdi: false,
      loadingDataError: false,
      splosniPogojiURL: '',
      formValidations: {},
      rules: {
        smartTvAppRules: [
          {
            validator: (rule, value, callback) => {
              callback(new Error('Vnešena koda ni pravilna. Prosimo, poskusite ponovno.'))
            },
            trigger: []
          }
        ]
      },
      orderCanceledPopup: false
    }
  },
  computed: {
    StoritevEnum () {
      return StoritevEnum
    },
    isFinalStep () {
      return this.activeStep === (this.numberOfSteps - 1)
    },
    numberOfSteps () {
      return (this.order.hasT2AppService() && !this.order.isSubscription) ? 2 : this.order.documents.length + 1
    },
    isDisabledNarocilo () {
      if (!this.strinjanjePogodba) {
        return true
      }
      if (!this.strinjanjeIzgubaPraviceDoOdstopa && this.order.isSubscription) {
        return true
      }
      if (
        this.order.hasT2AppService() && this.order.isSubscription
      ) {
        let smartTvService = this.order.getT2AppService()
        if (smartTvService.additionalData.smartTvApp === null || smartTvService.additionalData.smartTvApp.length < 5) {
          return true
        }
      }
      return false
    },
    documentsCheckboxes () {
      let checkBoxes = []
      this.order.documents.forEach(document => {
        document.checkBoxes.forEach(checkbox => {
          checkBoxes.push(checkbox)
        })
      })
      return checkBoxes
    }
  },
  async created () {
    try {
      this.splosniPogojiURL = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
      this.order.serviceName = this.serviceName
      this.validData = this.validateServices(this.services)
      if (!this.validData) {
        console.log('Napaka pri validaciji vhodnih parametrov')
      } else {
        this.order.parseServicesFromArrayOfObjects(this.services)
      }
      await this.order.create()
    } catch (e) {
      e.duration = 0
      this.loadingDataError = true
      this.ShowErrorMessage(e)
    }
    this.loading = false
  },
  methods: {
    handleDownload () {
      const povezava = this.$refs.docsPDFDownloader
      this.PrenesiDatoteko(povezava.getAttribute('href'), povezava.getAttribute('download'))
    },
    async confirmChange () {
      try {
        this.loadingPotrdi = true
        await this.order.signDocumentsAndComplete()
        this.pokaziSuccessPopup = true
        this.$emit('orderConfirmed')
      } catch (e) {
        if (this.order.hasT2AppService() && e.message === 'Vnešena koda ni pravilna. Prosimo, poskusite ponovno.') {
          this.$refs.T2TVSmartForm[0].validate((valid) => {})
        } else {
          e.duration = 0
          if (e.message === 'Neobstoječe naročilo.') {
            this.orderCanceledPopup = true
            e.message = 'Postopek spremembe naročenih storitev je bil preklican.'
          }
          this.ShowWarningMessage(e)
        }
      }
      this.loadingPotrdi = false
    },
    validateServices (arr) {
      if (!Array.isArray(arr)) {
        return false
      }
      for (let i = 0; i < arr.length; i++) {
        if (
          typeof arr[i] !== 'object' ||
          typeof arr[i].serviceId !== 'number' ||
          typeof arr[i].quantity !== 'number'
        ) {
          return false
        }
        if (
          (arr[i].terminationPointId === null || arr[i].terminationPointId === undefined) &&
          (arr[i].customerId === null || arr[i].customerId === undefined)
        ) {
          return false
        }
        if (Array.isArray(arr[i].additionalData)) {
          for (let j = 0; j < arr[i].additionalData.length; j++) {
            if (typeof arr[i].additionalData[j].key === 'undefined' || typeof arr[i].additionalData[j].value === 'undefined') {
              return false
            }
          }
        }
      }
      return true
    }
  },
  watch: {
    async cancelOrder (val) {
      if (val === true && this.order.id !== null) {
        try {
          await this.order.cancel()
        } catch (e) {
          e.duration = 0
          if (e.message !== 'Neobstoječe naročilo.') {
            this.ShowWarningMessage(e)
          }
        }
      }
      if (val === true && !this.orderCanceledPopup) {
        this.ShowWarningMessage({message: 'Postopek spremembe naročenih storitev je bil preklican.'})
      }
    },
    pokaziSuccessPopup (val) {
      if (val === false) {
        // dodamo pogoj če je narobe vpisana koda za smart tv
        this.$emit('notificationClose')
      }
    }
  }
}
</script>

<style>
.SpremembaStoritevComponent {
  display: flex;
  flex-direction: column;
}

.spremembaStoritevSuccessDialog .el-dialog__header {
  display:none;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/SpremembaStoritevComponent.vue